export default __webpack_public_path__ + "static/media/labelsitter-logo.d23cd86d.svg";